import { defineMessage } from 'services/localization';

export const messages = {
    reassignReviewerTitleText: defineMessage('reassign_the_request_to_another_reviewer'),
    editReviewerTitleText: defineMessage('change_the_reviewer_in_this_step'),
    skippedText: defineMessage('there_are_no_reviewers__epbrit_has_been_skipped'),
};
